export default __webpack_public_path__ + "static/hair_styling-6e8eb6966a7f4843de8c80929b2ed4c7.jpg";